import { render, staticRenderFns } from "./Top5Practices.vue?vue&type=template&id=2494fae8&"
import script from "./Top5Practices.vue?vue&type=script&lang=js&"
export * from "./Top5Practices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports